// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__12isb","clinicsSelect":"TableHeading_clinicsSelect__-MFoa"};